module.exports = __webpack_public_path__ + "img/course_index.dbe77b07.png";